import React from 'react';
import './Catering.css';

const Catering = () => {
  return (
    <main className="catering-container">
      <section className="catering-hero">
        <h1>Catering Made Easy</h1>
        <p>Elevate your next event with our exceptional catering services. From corporate meetings to special celebrations, we deliver quality and convenience.</p>
        <a 
          href="https://www.ezcater.com/catering/pvt/breakfast-at-drakes-3?fcv=1"
          target="_blank"
          rel="noopener noreferrer"
          className="order-button"
        >
          Order Catering Now
        </a>
      </section>
      
      <section className="catering-features">
        <div className="feature">
          <h3>Easy Online Ordering</h3>
          <p>Place your order quickly and easily through our trusted catering platform, available 24/7 for your convenience.</p>
        </div>
        <div className="feature">
          <h3>Flexible Options</h3>
          <p>Customize your menu from our extensive selection of appetizers, entrees, and party platters to suit any occasion.</p>
        </div>
        <div className="feature">
          <h3>Professional Service</h3>
          <p>Experience seamless service from our dedicated team, ensuring your event is a memorable success.</p>
        </div>
      </section>

      <section className="catering-cta">
        <h2>Ready to Order?</h2>
        <p>Browse our full catering menu and start planning your perfect event today</p>
        <a 
          href="https://www.ezcater.com/catering/pvt/breakfast-at-drakes-3?fcv=1"
          target="_blank"
          rel="noopener noreferrer"
          className="secondary-button"
        >
          View Full Catering Menu
        </a>
      </section>
    </main>
  );
};

export default Catering; 